export default __webpack_public_path__ + "static/media/scan-2.81d141ee.jpeg";